export default __webpack_public_path__ + "static/media/15.fac3b638.svg";